import { Constant } from '@configs/index';

export default class AmountCalculation {

    static differenceStyleClass = (fee: number) => {
        let styleClass;
        switch (Math.sign(fee)) {
            case 1:
                styleClass = 'text-danger';
                break;
            case -1:
                styleClass = 'text-success';
                break;
        }
        return styleClass;
    }

    static toLocaleString = (fee: number) => {
        const result = fee.toLocaleString();
        return result;
    }

    static addTax = (fee: number) => {
        const result = Math.round(fee * Constant.TAX_RATE);
        return result;
    }

    static removeTax = (fee: number) => {
        const result = Math.round(fee / Constant.TAX_RATE);
        return result;
    }

}